interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodyXLMediumRelaxed = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-xl font-medium leading-8 ${className}`}>
            {children}
        </p>
    );
};